import Button from '@/gf/components/ButtonOld'
import LinkButton from '@/gf/components/LinkButtonOld'
import TextArea from '@/gf/components/TextArea'
import useMsgs from '@/gf/hooks/useMsgs'
import useToggle from '@/gf/hooks/useToggle'
import { ADD_TIMELINE_NOTE } from '@/gf/mutations/quotes'
import { RequestForQuote } from '@/types'
import { ApolloError, useMutation } from '@apollo/client'
import { useState } from 'react'

const RFQCommentForm = ({
  rfq,
  refetch,
  isAdmin,
  openMessagesTab,
}: {
  rfq?: Pick<RequestForQuote, 'id'>
  refetch: () => void
  isAdmin: boolean
  openMessagesTab: () => void
}) => {
  const [commentText, setCommentText] = useState('')
  const [addTimelineEvent] = useMutation(ADD_TIMELINE_NOTE)
  const [_msgs, msgsMgr] = useMsgs()
  const [spinnerLive, spinner] = useToggle()

  const addTimelineNote = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    privacy: 'supplier_protected' | 'all_suppliers' | 'public' | 'protected' | 'private',
    storeId?: string
  ) => {
    e.preventDefault()

    if (commentText.trim() === '') {
      msgsMgr.add('Please insert a comment', 'negative')
      return
    }

    spinner.on()

    const variables = storeId
      ? { privacy, note: commentText, requestForQuoteId: rfq?.id, storeId }
      : { privacy, note: commentText, requestForQuoteId: rfq?.id }

    addTimelineEvent({ variables })
      .then(() => refetch())
      .then(() => {
        setCommentText('')
        msgsMgr.add('Timeline comment added.', 'positive')
      })
      .catch((err: ApolloError) => {
        const message = err.graphQLErrors.reduce((acc, error) => `${acc}${error.message}`, '')
        msgsMgr.add(message, 'negative')
      })
      .finally(() => {
        spinner.off()
      })
  }
  return (
    <form className="space-y-2">
      <TextArea
        placeholder="Leave a comment..."
        required
        value={commentText}
        onChange={(e) => setCommentText(e.target.value)}
      />

      <div className="flex justify-between items-start">
        <Button
          title="Post"
          disabled={!commentText || spinnerLive}
          performing={spinnerLive}
          onClick={(e) => addTimelineNote(e, isAdmin ? 'private' : 'supplier_protected')}
        />

        <div className="text-sm text-gray-500 space-x-2 space-y-0.5 text-right">
          <p>Only you and your team can see comments</p>

          <p>
            To contact the customer or Gearflow, go to the{' '}
            <LinkButton onClick={openMessagesTab}>messages tab</LinkButton>
          </p>
        </div>
      </div>
    </form>
  )
}

export default RFQCommentForm
